// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"id-document-validation_modalContent__rc3vu"};